import { entityPatientPayment, entityInsurance, entityCertificate } from '@/libs/acl/entities'

export default [
  {
    path: '/apps/cash-register',
    name: 'apps-cash-register',
    component: () => import('@/views/revenue/cash-register/CashRegister.vue'),
    meta: {
      contentClass: 'cash-register-application',
      resource: entityPatientPayment,
      action: 'read',
      title: 'Cash register',
    },
  },
  {
    path: '/apps/write-off',
    name: 'apps-write-off',
    component: () => import('@/views/revenue/write_off/WriteOff.vue'),
    meta: {
      contentClass: 'write-off-application',
      resource: entityPatientPayment,
      action: 'read',
      title: 'WriteOff',
    },
  },
  {
    path: '/apps/debtors',
    name: 'apps-debtors',
    component: () => import('@/views/revenue/debtors/Debtors.vue'),
    meta: {
      contentClass: 'debtors-application',
      resource: entityPatientPayment,
      action: 'read',
      title: 'Debtors',
    },
  },
  {
    path: '/apps/advances',
    name: 'apps-advances',
    component: () => import('@/views/revenue/advances/Advances.vue'),
    meta: {
      contentClass: 'advances-application',
      resource: entityPatientPayment,
      action: 'read',
      title: 'Advances',
    },
  },
  {
    path: '/apps/insurance',
    name: 'apps-insurance',
    component: () => import('@/views/revenue/insurance/Insurance.vue'),
    meta: {
      contentClass: 'insurance-application',
      resource: entityInsurance,
      action: 'read',
      title: 'Insurance',
    },
  },
  {
    path: '/apps/certificate',
    name: 'apps-certificate',
    component: () => import('@/views/revenue/certificate/Certificate.vue'),
    meta: {
      contentClass: 'certificate-application',
      resource: entityCertificate,
      action: 'read',
      title: 'Certificates',
    },
  },
  {
    path: '/apps/cashless-payment',
    name: 'apps-cashless-payment',
    component: () => import('@/views/revenue/сashless-payment/CashlessPayment.vue'),
    meta: {
      contentClass: 'cashless-payment-application',
      resource: entityPatientPayment,
      action: 'read',
      title: 'Cashless payment',
    },
  },
]
